import ticketFeedbackService from "../../../services/ticketService/feedbackService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_TICKETFEEDBACK } from "../../../utils/constants";
import { TicketFeedbackInterface } from "../../../models/TicketModule/TicketFeedback";

interface AddFeedbackContext {
  previousFeedbacks: TicketFeedbackInterface[];
}

const useAddFeedback = (ticketId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    TicketFeedbackInterface,
    Error,
    TicketFeedbackInterface,
    AddFeedbackContext
  >({
    mutationFn: ticketFeedbackService.Add,

    onMutate: () => {
      const previousCustomers =
        queryClient.getQueryData<TicketFeedbackInterface[]>([
          CACHE_KEY_TICKETFEEDBACK,
          ticketId,
        ]) || [];

      return { previousFeedbacks: previousCustomers };
    },

    onSuccess: (savedCustomer) => {
      queryClient.setQueryData<TicketFeedbackInterface[]>(
        [CACHE_KEY_TICKETFEEDBACK, ticketId],
        (customers) =>
          customers ? [...customers, savedCustomer] : [savedCustomer]
      );
    },

    onError: (error, newCustomer, context) => {
      if (!context) return;

      queryClient.setQueryData<TicketFeedbackInterface[]>(
        [CACHE_KEY_TICKETFEEDBACK, ticketId],
        context.previousFeedbacks
      );
    },
  });
};

export default useAddFeedback;
